export type NavSection = "main" | "user" | "creator" | "partner" | "admin";

export type NavItem = {
  key: string;
  to: string;
  label: string;
  section: NavSection;
  auth?: boolean;
  admin?: boolean;
  creator?: boolean;
  disabled?: boolean;
  showInLauncher?: boolean;
};

export const NAV_ITEMS: NavItem[] = [
  // 🌍 MAIN
  {
    key: "home",
    to: "/",
    label: "🌐 Digital Shop",
    section: "main",
    showInLauncher: true,
  },
  {
    key: "community",
    to: "/community",
    label: "🗣 Community",
    section: "main",
    showInLauncher: true,
  },

  // 📚 USER
  {
    key: "library",
    to: "/my-library",
    label: "📚 My Library",
    section: "user",
    auth: true,
    showInLauncher: true,
  },
  {
    key: "agent",
    to: "/agent",
    label: "⚡ Agent Market",
    section: "user",
    auth: true,
    showInLauncher: true,
  },
  {
    key: "transactions",
    to: "/my-transactions",
    label: "🧾 My Transactions",
    section: "user",
    auth: true,
    showInLauncher: true,
  },
  {
    key: "profile",
    to: "/profile",
    label: "🙍 Profile",
    section: "user",
    auth: true,
    showInLauncher: true,
  },

  // ✍️ CREATOR
  {
    key: "my-ebooks",
    to: "/creator/ebooks/mine",
    label: "📘 My Ebooks",
    section: "creator",
    auth: true,
    creator: true,
    showInLauncher: true,
  },
  {
    key: "upload-ebook",
    to: "/creator/ebooks/new",
    label: "➕ Upload Ebook",
    section: "creator",
    auth: true,
    creator: true,
    showInLauncher: true,
  },
  {
    key: "creator-payouts",
    to: "/creator/payouts",
    label: "💰 Payouts",
    section: "creator",
    auth: true,
    creator: true,
    showInLauncher: true,
  },

  // 🤝 PARTNER
  {
    key: "partner-apply",
    to: "/partner/apply",
    label: "🤝 Become Partner",
    section: "partner",
    showInLauncher: true,
  },
  {
    key: "partner-dashboard",
    to: "/partner/dashboard",
    label: "📊 Partner Dashboard",
    section: "partner",
    auth: true,
    showInLauncher: true,
  },

  // 🛠 ADMIN
  {
    key: "admin-ebooks",
    to: "/admin/ebooks/pending",
    label: "🛠 Pending Ebooks",
    section: "admin",
    admin: true,
    showInLauncher: true,
  },
  {
    key: "admin-partners",
    to: "/admin/partners",
    label: "🤝 Partner Applications",
    section: "admin",
    admin: true,
    showInLauncher: true,
  },
];

export const NAV_BY_KEY: Record<string, NavItem> = Object.fromEntries(
  NAV_ITEMS.map((item) => [item.key, item])
);